"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIVALIA_GOLD_COLOR = exports.PRIVALIA_DEFAULT_COLOR = exports.PRIVALIA_HOVER_COLOR = exports.DEFAULT_LOCALE = void 0;
exports.DEFAULT_LOCALE = 'es-ES';
exports.PRIVALIA_HOVER_COLOR = '#e55253';
exports.PRIVALIA_DEFAULT_COLOR = '#777777';
exports.PRIVALIA_GOLD_COLOR = '#d1994c';
